import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
export var AuthErrorCodes;
(function (AuthErrorCodes) {
  AuthErrorCodes["Unauthorized"] = "UNAUTHORIZED";
  AuthErrorCodes["InternalError"] = "INTERNAL_ERROR";
  AuthErrorCodes["MissingApiKey"] = "MISSING_API_KEY";
})(AuthErrorCodes || (AuthErrorCodes = {}));
export var AuthError = /*#__PURE__*/function (_Error) {
  _inherits(AuthError, _Error);
  var _super = _createSuper(AuthError);
  function AuthError(_ref) {
    var _this;
    var _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$code = _ref.code,
      code = _ref$code === void 0 ? AuthErrorCodes.InternalError : _ref$code;
    _classCallCheck(this, AuthError);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "name", void 0);
    _defineProperty(_assertThisInitialized(_this), "code", void 0);
    _this.name = 'AuthError';
    _this.code = code;
    return _this;
  }
  return _createClass(AuthError);
}( /*#__PURE__*/_wrapNativeSuper(Error));